import { EmptyState, Flex, Icons, Heading, Paragraph, Button } from "@ir/ui";
import { PageContent } from "@src/presentation/components/Layout/common";
import { useNavigate } from "react-router";

export const NotFound = () => {
  const navigate = useNavigate();
  return (
    <PageContent>
      <Flex align="center" justifyContent="center" style={{ height: "100vh" }}>
        <EmptyState
          className="bg-white border-1 border-color-grey-25 px-4 py-5 m-4"
          icon={Icons.InfoOctagon}
          title={
            <Heading level={6} className="text-grey-700 font-bold mt-3">
              404 - Page Not Found
            </Heading>
          }
          description={
            <>
              <Paragraph className="text-grey-500 font-regular mb-0">
                The page you are looking for might have been removed or is
                temporarily unavailable.
              </Paragraph>
              <Button
                className="mt-4"
                variant="outline"
                onPress={() => {
                  navigate("/");
                }}
              >
                Go to Dashboard
              </Button>
            </>
          }
        />
      </Flex>
    </PageContent>
  );
};
